import { User } from "lucide-react";
import moment from "moment";

import { BasicTooltip } from "@/components/ui/Tooltip";
import { formatTimestamp } from "@/utils/timestamp";

const VersionMetadata = ({
  created_at,
  author,
}: {
  created_at: string;
  author: string | undefined;
}) => {
  const createdMoment = moment(created_at);
  const relativeTimestamp = createdMoment.isValid()
    ? formatTimestamp(createdMoment)
    : "Invalid date";
  const absoluteTimestamp = createdMoment.isValid()
    ? createdMoment.format("MMMM Do YYYY, h:mm:ss a")
    : "Invalid date";

  return (
    <div className="ml-6 flex items-center justify-between">
      <div className="truncate overflow-ellipsis py-0.5 text-xs text-gray-500">
        <BasicTooltip content={absoluteTimestamp}>
          <span>{relativeTimestamp}</span>
        </BasicTooltip>
        {author && (
          <>
            <span className="px-1 text-gray-400">•</span>
            <User className="inline h-3 w-auto pr-1" />
            <span className="truncate overflow-ellipsis">{author}</span>
          </>
        )}
      </div>
    </div>
  );
};

export default VersionMetadata;
